import { render, staticRenderFns } from "./crossevent.vue?vue&type=template&id=a6bff942"
import script from "./crossevent.vue?vue&type=script&lang=js"
export * from "./crossevent.vue?vue&type=script&lang=js"
import style0 from "./crossevent.vue?vue&type=style&index=0&id=a6bff942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports